<template>
    <div class="d-flex d-flex-end vertical-center mt-35px">
        <label class="alimentation-label">{{ alimentationType.label }}</label>
        <div class="position-relative">
            <input type="number" class="alimentation-input" v-model="result.percent" @input="$emit('update:modelValue', result) " min="0"/>
            <div class="percent-alimentation">%</div>
        </div>
    </div>
</template>
<script>
export default{
    data(){
        return {
            result:{
              percent:null
            }
        }
    },
    props:{
        alimentationType:Object,
        modelValue: Object
  },
  watch: {
    modelValue(newVal) {
      this.result = newVal;
    }
  },
  mounted(){
    this.result.factor=this.alimentationType.factor
  }
}
</script>
<style>
.percent-alimentation{
    position:absolute;
    top:50%;
    transform: translateY(-50%);
    right:40px;
    color: #BAB1B1;
    text-align: center;
    font-family: var(--font);
    font-size: 42px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}
.alimentation-label{
    color: var(--text-color);
    text-align: right;
    font-family: var(--font);
    font-size: 32px;
    font-style: normal;
    font-weight: 900;
    line-height: 1.1em; /* 103.75% */
    padding-right: 25px;
}
.alimentation-input{
    font-family: var(--font);
    font-size: 25px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    display: flex;
    padding: 22px 36px;
    border-radius: 0px 0px 50px 0px;
    border: 3px solid var(--Secondary-Noir, #3B3B3C);
    box-shadow: 4px 4px 24px 0px rgba(0, 0, 0, 0.15);
}
/* Chrome, Safari, Edge, Opera */
input.alimentation-input::-webkit-outer-spin-button,
input.alimentation-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* Firefox */
input.alimentation-input[type=number] {
  -moz-appearance: textfield;
}
@media screen and (max-width: 1500px) {
  .alimentation-label{
    font-size: 28px;
  }
  .alimentation-input{
    padding: 15px 25px;
  }
}

@media screen and (max-width: 1300px) {
  .alimentation-label{
    font-size: 26px;
  }
}

@media screen and (max-width: 992px) {
  .alimentation-label{
        font-size: 25px;
    }
    .percent-alimentation{
        font-size: 25px;
    }
    .alimentation-input{
        font-size: 20px;
        padding:15px 20px;
    }

}

@media screen and (max-width: 750px) {
  
}
@media screen and (max-width: 600px) {
  .alimentation-label{
    font-size: 20px;
    width:100%;
    text-align: left;
  }
  .alimentation-input{
    width:100%;
    font-size: 20px;
    padding-left: 5px;
    padding-right: 20px;
    box-sizing: border-box;
  }
  .percent-alimentation{
    right:20px;
    font-size: 30px;
  }
}
</style>